/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent, MouseEvent as ReactMouseEvent } from 'react';
import { HeaderSubSection } from 'src/components/ZillowNavbar/page-frame-types/HeaderSubSection';
import { HeaderLink } from 'src/components/ZillowNavbar/page-frame-types/HeaderLink';
import { HeaderLinkDescription } from 'src/components/ZillowNavbar/page-frame-types/HeaderLinkDescription';
import { ZillowNavbarSubSectionContainer } from './components/ZillowNavbarSubSectionContainer';
import { ZillowNavbarSubSectionTitle } from './components/ZillowNavbarSubSectionTitle';
import { ZillowNavbarSubSectionLinks } from './components/ZillowNavbarSubSectionLinks';

export type ZillowNavbarSubSectionProps = {
    subsection: HeaderSubSection;
    isVertical: boolean;
    onLinkClick: (
        link: HeaderLink | HeaderLinkDescription,
        event: ReactMouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
};

export const ZillowNavbarSubSection: FunctionComponent<ZillowNavbarSubSectionProps> = ({
    onLinkClick,
    subsection,
    isVertical,
}) => (
    <ZillowNavbarSubSectionContainer isVertical={isVertical}>
        {!!subsection.title && <ZillowNavbarSubSectionTitle level={6}>{subsection.title}</ZillowNavbarSubSectionTitle>}
        <ZillowNavbarSubSectionLinks onLinkClick={onLinkClick} links={subsection.links} />
    </ZillowNavbarSubSectionContainer>
);
